export function createProductPatcher(data) {
    return {
        __typename: 'CreateProductMutation',
        ...data,
        createProduct: {
            __typename: 'CreateProduct',
            ...data.createProduct,
        },
    };
}
